<template>
  <div class="v-tabs-mts">
    <ul class="v-tabs-mts__list">
      <li
        v-for="tab in tabs"
        :key="tab.name"
        class="v-tabs-mts__list-item"
        :class="{ '--is-active': tab.isActive }"
        @click="selectTab(tab)"
      >
        {{ tab.name }}
      </li>
    </ul>
    <div class="v-tabs-mts__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VTabsMTS',
  data() {
    return {
      tabs: [],
    }
  },
  created() {
    this.tabs = this.$children
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        tab.isActive = tab.name === selectedTab.name
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.v-tabs-mts {
  font-family: $font-mts-compact;

  .container {
      padding-left: 20px;
      padding-right: 20px;
  }

  &__list {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-bottom: 40px;

    @include screen-down('lg') {
      max-width: 591px;
    }

    @include screen-down('md') {
      margin-bottom: 24px;
    }

    &-item {
      display: flex;
      justify-content: center;
      width: fit-content;
      background-color: #ffffff;
      border-radius: 16px;
      padding: 12px;
      font-size: 17px;
      line-height: 24px;
      margin-right: 8px;
      margin-bottom: 8px;
      cursor: pointer;
      transition: 0.3s ease-out;

      @include screen-down('md') {
        font-size: 14px;
        line-height: 20px;
      }

      &.--is-active {
        background: $color-dark-2;
        color: $color-light;
      }
    }
  }
}
</style>
